import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Menu',
    displayName: 'Menu',
    displayNameTH: 'เมนู',
    subtext: 'default'
  },
   {
     displayName: 'Dashboard',
     displayNameTH:'แดชบอร์ด',
    iconName: 'lock-access',
    route: 'admin/dashboard',
     subtext: 'admin.dashboard.view'
  },
  {
    displayName: 'Profile',
    displayNameTH: 'โปรไฟล์',
    iconName: 'address-book',
    route: 'user/profile',
    subtext: 'default'
  },
  {
    displayName: 'Profile',
    displayNameTH: 'โปรไฟล์',
    iconName: 'address-book',
    route: 'user/profile',
    subtext: 'default.corp'
  },
  {
    displayName: 'Profile',
    displayNameTH: 'โปรไฟล์',
    iconName: 'address-book',
    route: 'user/profile',
    subtext: 'default.admin'
  },
  {
    displayName: 'Register',
    displayNameTH: 'ลงทะเบียน',
    iconName: 'ballpen',
    route: 'user/course',
    subtext: 'default'
  },
  {
    displayName: 'Register',
    displayNameTH: 'ลงทะเบียน',
    iconName: 'ballpen',
    route: 'user/course',
    subtext: 'default.admin'
  },
  {
    displayName: 'Register Group',
    displayNameTH: 'ลงทะเบียนกลุ่ม',
    iconName: 'ballpen',
    route: 'request/course-request-group',
    subtext: 'default.admin'
  },
  {
    displayName: 'Register Group',
    displayNameTH: 'ลงทะเบียนกลุ่ม',
    iconName: 'ballpen',
    route: 'request/course-request-group',
    subtext: 'default.corp'
  },
 
  {
    displayName: 'My Course',
    displayNameTH: 'หลักสูตรของฉัน',
    iconName: 'history',
    route: 'user/history',
    subtext: 'default'
  },
  {
    displayName: 'My Course',
    displayNameTH: 'หลักสูตรของฉัน',
    iconName: 'history',
    route: 'user/history',
    subtext: 'default.corp'
  },
  {
    navCap: 'Admin',
    displayName: 'Admin',
    displayNameTH: 'แอดมิน',
    subtext: 'admin.dashboard.view'
  },
  {
    displayName: 'Course Application',
    displayNameTH: 'ใบสมัครหลักสูตร',
    iconName: 'checklist',
    route: 'admin/worklist',
    subtext: 'admin.dashboard.view'
  },
  {
    displayName: 'Corporate',
    displayNameTH: 'บริษัท',
    iconName: 'building-estate',
    route: '/admin',
    subtext: 'admin.dashboard.view',
    children: [
      {
        displayName: 'Corporate',
        displayNameTH: 'บริษัทลูกค้า',
        iconName: 'point',
        route: '/admin/createcorporate',
        subtext: 'master.corporate.view'
      },
      {
        displayName: 'Company(Internal)',
        displayNameTH: 'บริษัท (ภายใน)',
        iconName: 'point',
        route: '/admin/createcompany',
        subtext: 'master.internalcompany.view'
      },
    ],
  },
  {
    displayName: 'Course',
    displayNameTH:'หลักสูตร',
    iconName: 'certificate',
    route: '/authentication',
    subtext: 'master.course.view',
    children: [
      {
        displayName: 'Course Type',
        displayNameTH: 'ประเภทหลักสูตร',
        iconName: 'point',
        route: 'admin/createcoursetype',
        subtext: 'master.coursetype.view',
      },
      {
        displayName: 'Course',
        displayNameTH: 'หลักสูตร',
        iconName: 'point',
        route: 'admin/createcourse',
        subtext: 'master.course.view',
      },
      {
        displayName: 'Device',
        displayNameTH: 'อุปกรณ์',
        iconName: 'point',
        route: 'admin/createdevice',
        subtext: 'master.course.view',
      },
      {
        displayName: 'License',
        displayNameTH: 'ใบอนุญาต',
        iconName: 'point',
        route: 'admin/createlicensetype',
        subtext: 'master.licensetype.view',
      },
      {
        displayName: 'Training',
        displayNameTH: 'การฝึกอบรม',
        iconName: 'point',
        route: 'admin/createtraining',
        subtext: 'master.training.view',
      },
      {
        displayName: 'Promotion Code',
        displayNameTH: 'รหัสโปรโมชั่น',
        iconName: 'point',
        route: 'admin/promotioncode',
        subtext: 'master.promotioncode.view',
      },

    ],
  },
  {
    displayName: 'Invoice',
    displayNameTH: 'ใบแจ้งหนี้',
    iconName: 'businessplan',
    route: '/admin',
    subtext: 'request.invoice.view',
    children: [
      {
        displayName: 'New Invoice',
        displayNameTH: 'ออกใบแจ้งหนี้ใหม่',
        iconName: 'point',
        route: 'admin/invoice',
        subtext: 'request.invoice.view',
      },
      {
        displayName: 'Status',
        displayNameTH: 'สถานะใบแจ้งหนี้',
        iconName: 'point',
        route: 'admin/invoice-worklist',
        subtext: 'request.invoice.view',
      }
    ],
  },
  {
    displayName: 'Receipt',
    displayNameTH: 'ใบเสร็จรับเงิน',
    iconName: 'receipt-2',
    route: '/admin',
    subtext: 'request.receipt.view',
    children: [
      {
        displayName: 'New Receipt',
        displayNameTH: 'ออกใบเสร็จใหม่',
        iconName: 'point',
        route: 'admin/receipt',
        subtext: 'request.receipt.view',
      },
      {
        displayName: 'Status',
        displayNameTH: 'สถานะใบเสร็จ',
        iconName: 'point',
        route: 'admin/receipt-worklist',
        subtext: 'request.receipt.view',
      }
    ],
  },
  {
    displayName: 'Credit Note',
    displayNameTH: 'ใบลดหนี้',
    iconName: 'receipt-refund',
    route: '/admin',
    subtext: 'request.creditdebit.view',
    children: [
      {
        displayName: 'New Credit Note',
        displayNameTH: 'ออกใบลดหนี้ใหม่',
        iconName: 'point',
        route: 'admin/cndn',
        subtext: 'request.creditdebit.view',
      },
      {
        displayName: 'Status',
        displayNameTH: 'สถานะใบลดหนี้',
        iconName: 'point',
        route: 'admin/cndn-worklist',
        subtext: 'request.creditdebit.view',
      }
    ],
  },
  {
    navCap: 'Report',
    displayName: 'Report',
    displayNameTH: 'รายงาน',
    route: '/report',
    subtext: 'report.etax.view'
  },
  {
    displayName: 'ETAX Report',
    displayNameTH: 'รายงาน e-Tax',
    iconName: 'article',
    route: 'report/etax-report',
    subtext: 'report.etax.view'
  },
  //{
  //  displayName: 'Financial Report',
  //  displayNameTH: 'รายงานการเงิน',
  //  iconName: 'article',
  //  route: 'report/financial-report',
  //  subtext: 'report.financial.view'
  //},
  {
    displayName: 'Payment Daily Report',
    displayNameTH: 'รายงานการเงินประจำวัน',
    iconName: 'article',
    route: 'report/payment-report',
    subtext: 'report.financial.view'
  },
  {
    navCap: 'Content Management',
    displayName: 'Content Management',
    displayNameTH: 'จัดการเนื้อหา',
    subtext: 'admin.article.view'
  },
  {
    displayName: 'Article',
    displayNameTH: 'บทความ',
    iconName: 'article',
    route: '/admin/article',
    subtext: 'admin.article.view'
  },
  {
    displayName: 'Article Tag',
    displayNameTH: 'แท็กบทความ',
    iconName: 'article',
    route: '/admin/tag',
    subtext: 'admin.articletag.view'
  },
  //{
  //  displayName: 'Career',
  //  iconName: 'desk',
  //  route: '/admin/career',
  //  subtext: 'Admin'
  //},
  {
    displayName: 'Page',
    displayNameTH: 'หน้าเว็บ',
    iconName: 'article',
    route: '/admin/masterpage',
    subtext: 'admin.page.view'
  },
  {
    displayName: 'Content',
    displayNameTH: 'เนื้อหา',
    iconName: 'menu',
    route: '/authentication',
    subtext: 'admin.contentmenu.view',
    children: [
      {
        displayName: 'Menu',
        displayNameTH: 'เมนู',
        iconName: 'point',
        route: '/admin/menu',
        subtext: 'admin.contentmenu.view'
      },
      {
        displayName: 'Sub-Menu',
        displayNameTH: 'เมนูย่อย',
        iconName: 'point',
        route: '/admin/sub-menu',
        subtext: 'admin.contentsubmenu.view'
      },
      {
        displayName: 'Cookies',
        displayNameTH: 'คุกกี้',
        iconName: 'point',
        route: '/admin/cookie',
        subtext: 'admin.contentcookies.view'
      },
    ],
  },
  {
    displayName: 'Header/Footer',
    displayNameTH: 'ส่วนหัว/ส่วนท้าย',
    iconName: 'forms',
    route: '/admin/header-footer',
    subtext: 'admin.contentheaderfooter.view'
  },
  {
    displayName: 'Field',
    displayNameTH: 'ฟิลด์',
    iconName: 'forms',
    route: '/admin/field',
    subtext: 'admin.field.view'
  },
  {
    displayName: 'Object',
    displayNameTH: 'อ็อบเจกต์',
    iconName: 'forms',
    route: '/object',
    subtext: 'object.accordian.view',
    children: [
      {
        displayName: 'Accordian',
        displayNameTH: 'แถบพับเก็บได้ (Accordian)',
        iconName: 'point',
        route: '/admin/accordian-content',
        subtext: 'object.accordian.view'
      },
      {
        displayName: 'Block',
        displayNameTH: 'บล็อก',
        iconName: 'point',
        route: '/admin/block-content',
        subtext: 'object.block.view'
      },
      {
        displayName: 'Card',
        displayNameTH: 'การ์ด',
        iconName: 'point',
        route: '/admin/card-content',
        subtext: 'object.card.view'
      },
      {
        displayName: 'Circular',
        displayNameTH: 'หนังสือเวียน',
        iconName: 'point',
        route: '/admin/circular-content',
        subtext: 'object.circular.view'
      },
      {
        displayName: 'Client',
        displayNameTH: 'ลูกค้า',
        iconName: 'point',
        route: '/admin/client-content',
        subtext: 'object.client.view'
      },
      {
        displayName: 'Contact Us',
        displayNameTH: 'ติดต่อเรา',
        iconName: 'point',
        route: '/admin/contactus-content',
        subtext: 'object.contactus.view'
      },
      {
        displayName: 'Image',
        displayNameTH: 'รูปภาพ',
        iconName: 'point',
        route: '/admin/image-content',
        subtext: 'object.image.view'
      },
      {
        displayName: 'Text Image',
        displayNameTH: 'ข้อความและรูปภาพ',
        iconName: 'point',
        route: '/admin/textimage-content',
        subtext: 'object.textimage.view'
      },
      {
        displayName: 'Testimonial',
        displayNameTH: 'คำรับรอง',
        iconName: 'point',
        route: '/admin/testimonial-content',
        subtext: 'object.testimonial.view'
      },
      {
        displayName: 'Timeline',
        displayNameTH: 'ไทม์ไลน์',
        iconName: 'point',
        route: '/admin/timeline-content',
        subtext: 'object.timeline.view'
      },
      {
        displayName: 'Trusted Company',
        displayNameTH: 'บริษัทที่ไว้วางใจ',
        iconName: 'point',
        route: '/admin/trustedcompany-content',
        subtext: 'object.trustedcompany.view'
      }
    ],
  },
  {
    navCap: 'Management',
    displayName: 'Management',
    displayNameTH: 'การจัดการ',
    subtext: 'management.user.view',
  },
  {
    displayName: 'User',
    displayNameTH: 'ผู้ใช้',
    iconName: 'user',
    route: 'admin/usermgnt',
    subtext: 'management.user.view',
  },
  //{
  //  displayName: 'Email Template',
  //  iconName: 'mail',
  //  route: 'admin/emailmgt',
  //  subtext: 'Admin',
  //},
  {
    displayName: 'Group & Role',
    displayNameTH: 'จัดการกรุป',
    iconName: 'user',
    route: 'admin/groupmgnt',
    subtext: 'management.group.view',
  },
  //{
  //  displayName: 'Configuration',
  //  iconName: 'currency-dollar',
  //  route: 'admin/configurationmgnt',
  //  subtext: 'AdminIT',
  //},

];
